var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconCategoryBurger(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 151,
    height: 150,
    viewBox: "0 0 151 150",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_465_8501)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.90521 124.393C1.90521 134.378 8.9061 142.985 18.6779 145.038C33.3384 148.117 53.4305 150.016 75.5976 150.016C97.7646 150.016 117.857 148.117 132.517 145.038C142.289 142.985 149.29 134.378 149.29 124.393C149.29 120.984 145.987 118.534 142.734 119.553C128.103 124.136 103.498 127.146 75.5976 127.146C47.6976 127.146 23.0926 124.136 8.4611 119.553C5.20815 118.534 1.90521 120.984 1.90521 124.393Z",
    fill: "url(#paint0_linear_465_8501)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.2054 126.834L83.3089 149.937C102.404 149.553 119.577 147.755 132.517 145.037C136.209 144.262 139.503 142.55 142.176 140.183L125.474 123.481C111.707 125.777 94.4039 127.146 75.5975 127.146C70.3345 127.146 65.1892 127.039 60.2054 126.834Z",
    fill: "url(#paint1_linear_465_8501)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.734 119.553C136.735 121.432 129.056 123.046 120.163 124.298L138.602 142.737C145.066 139.07 149.291 132.148 149.291 124.393C149.29 120.984 145.987 118.534 142.734 119.553Z",
    fill: "url(#paint2_linear_465_8501)"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M22.1173 133.633C23.4865 133.633 24.5965 132.523 24.5965 131.154C24.5965 129.785 23.4865 128.675 22.1173 128.675C20.7482 128.675 19.6382 129.785 19.6382 131.154C19.6382 132.523 20.7482 133.633 22.1173 133.633Z",
    fill: "url(#paint3_linear_465_8501)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M17.5143 139.523C18.5953 139.523 19.4716 138.646 19.4716 137.565C19.4716 136.484 18.5953 135.608 17.5143 135.608C16.4333 135.608 15.5569 136.484 15.5569 137.565C15.5569 138.646 16.4333 139.523 17.5143 139.523Z",
    fill: "url(#paint4_linear_465_8501)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M26.0452 140.388C26.6969 140.388 27.2252 139.859 27.2252 139.208C27.2252 138.556 26.6969 138.028 26.0452 138.028C25.3935 138.028 24.8652 138.556 24.8652 139.208C24.8652 139.859 25.3935 140.388 26.0452 140.388Z",
    fill: "url(#paint5_linear_465_8501)"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M35.2264 134.855C36.2382 134.855 37.0584 134.034 37.0584 133.022C37.0584 132.011 36.2382 131.19 35.2264 131.19C34.2146 131.19 33.3943 132.011 33.3943 133.022C33.3943 134.034 34.2146 134.855 35.2264 134.855Z",
    fill: "url(#paint6_linear_465_8501)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M29.4281 135.092C30.2268 135.092 30.8743 134.444 30.8743 133.646C30.8743 132.847 30.2268 132.2 29.4281 132.2C28.6294 132.2 27.982 132.847 27.982 133.646C27.982 134.444 28.6294 135.092 29.4281 135.092Z",
    fill: "url(#paint7_linear_465_8501)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M32.7266 140.025C33.2082 140.025 33.5986 139.635 33.5986 139.153C33.5986 138.672 33.2082 138.281 32.7266 138.281C32.245 138.281 31.8545 138.672 31.8545 139.153C31.8545 139.635 32.245 140.025 32.7266 140.025Z",
    fill: "url(#paint8_linear_465_8501)"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M3.58987 132.647C6.22752 138.839 11.7555 143.584 18.6775 145.038C33.3381 148.117 53.4302 150.016 75.5972 150.016C97.7643 150.016 117.856 148.117 132.517 145.038C139.439 143.584 144.967 138.839 147.605 132.647H3.58987Z",
    fill: "url(#paint9_linear_465_8501)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.90521 104.363V109.115C1.90521 115.991 6.53904 122.031 13.2002 123.738C28.107 127.556 50.5249 129.986 75.5976 129.986C100.67 129.986 123.088 127.556 137.995 123.738C144.656 122.031 149.29 115.992 149.29 109.115V104.363C149.29 100.954 145.987 98.5039 142.734 99.523C128.103 104.107 103.498 107.116 75.5976 107.116C47.6976 107.116 23.0926 104.107 8.4611 99.523C5.20815 98.5039 1.90521 100.954 1.90521 104.363Z",
    fill: "url(#paint10_linear_465_8501)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.735 99.5229C128.103 104.106 103.498 107.116 75.5981 107.116C47.6981 107.116 23.0931 104.106 8.46159 99.5229C6.66423 98.9599 4.85482 99.459 3.59247 100.591L29.9913 126.989C42.9948 128.88 58.6907 129.986 75.5978 129.986C100.67 129.986 123.088 127.556 137.995 123.738C144.656 122.031 149.29 115.991 149.29 109.115V104.363C149.29 100.954 145.987 98.5037 142.735 99.5229Z",
    fill: "url(#paint11_linear_465_8501)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.29 109.115V105.776L142.978 99.4629C142.896 99.4841 142.815 99.4976 142.735 99.5232C134.919 101.971 124.256 103.97 111.767 105.301V113.471C111.767 115.303 112.596 116.94 113.898 118.032L122.641 126.776C128.349 125.907 133.514 124.886 137.995 123.738C144.657 122.031 149.29 115.991 149.29 109.115Z",
    fill: "url(#paint12_linear_465_8501)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.698 105.705C97.8517 106.613 87.0006 107.116 75.5976 107.116C64.2476 107.116 53.4435 106.618 43.6338 105.718C42.7317 107.347 42.8741 109.503 44.3659 110.994L63.1529 129.782C67.2109 129.915 71.365 129.986 75.5976 129.986C95.5209 129.986 113.763 128.451 127.897 125.904L107.698 105.705Z",
    fill: "url(#paint13_linear_465_8501)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.987 103.644C85.8241 97.8383 65.3712 97.8383 46.2082 103.644C43.015 104.612 42.0064 108.635 44.3659 110.994L67.1556 133.784C71.8179 138.446 79.3773 138.446 84.0397 133.784L106.829 110.994C109.189 108.635 108.18 104.612 104.987 103.644Z",
    fill: "url(#paint14_linear_465_8501)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.29 96.5497C149.29 75.7038 1.90521 75.7038 1.90521 96.5497C1.90521 100.144 6.28904 103.118 13.5417 105.473C16.1764 106.328 18.6064 107.716 20.6382 109.599L20.8561 109.801C25.2737 113.895 31.6696 115.044 37.2355 112.743L37.2396 112.741C41.9943 110.776 47.4155 111.304 51.7011 114.151L52.1087 114.422C56.8343 117.561 62.9114 117.819 67.8855 115.091L68.2655 114.882C72.834 112.377 78.3652 112.376 82.934 114.881L83.317 115.091C88.2917 117.818 94.369 117.559 99.0943 114.42L99.5887 114.091C103.85 111.26 109.247 110.754 113.961 112.741C119.486 115.071 125.864 113.949 130.262 109.873L130.558 109.599C132.589 107.716 135.019 106.328 137.654 105.472C144.906 103.118 149.29 100.144 149.29 96.5497Z",
    fill: "url(#paint15_linear_465_8501)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.29 96.5491C149.29 100.144 144.905 103.114 137.652 105.469C135.019 106.327 132.588 107.715 130.557 109.598L130.261 109.872C127.39 112.537 123.664 113.939 119.89 113.939C117.89 113.939 115.873 113.548 113.963 112.739C109.25 110.753 103.853 111.261 99.5888 114.091L99.0943 114.419C94.3717 117.556 88.292 117.816 83.3179 115.089L82.9358 114.878C78.3661 112.375 72.8346 112.375 68.2646 114.882L67.8873 115.089C62.9132 117.816 56.8335 117.56 52.1108 114.419L51.702 114.15C47.4152 111.301 41.9961 110.775 37.242 112.739H37.2376C33.9799 114.082 30.4435 114.253 27.1814 113.336L8.21463 94.3697C7.20374 93.4394 6.34992 92.3477 5.68933 91.1435C14.1729 85.5312 35.8673 82.2285 59.8982 81.2356C70.2196 80.8088 80.977 80.8088 91.2982 81.2356C122.231 82.5118 149.29 87.6162 149.29 96.5491Z",
    fill: "url(#paint16_linear_465_8501)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.492 81.6206C36.3297 82.6368 21.8161 84.7515 12.5244 87.9665C12.8273 89.3968 13.6388 90.6385 14.7676 91.4885L36.3509 113.072C36.6476 112.97 36.9435 112.864 37.2359 112.743L37.24 112.741C41.9947 110.776 47.4159 111.304 51.7014 114.151L52.1091 114.422C56.8347 117.561 62.9117 117.819 67.8859 115.091L68.2659 114.882C72.8344 112.377 78.3656 112.377 82.9344 114.881L83.3173 115.091C84.65 115.821 86.0623 116.331 87.5059 116.635L52.492 81.6206Z",
    fill: "url(#paint17_linear_465_8501)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.933 93.4178H111.767V112.014C112.51 112.201 113.244 112.439 113.962 112.741C119.487 115.071 125.865 113.949 130.263 109.873L130.558 109.599C132.59 107.716 135.02 106.328 137.654 105.472C140.875 104.427 143.527 103.259 145.484 101.969L136.933 93.4178Z",
    fill: "url(#paint18_linear_465_8501)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.767 93.4178V113.471C111.767 116.759 114.433 119.424 117.72 119.424C121.008 119.424 123.674 116.759 123.674 113.471V109.408C123.674 108.269 124.597 107.346 125.736 107.346C126.875 107.346 127.798 108.269 127.798 109.408V109.739C127.798 112.261 129.843 114.306 132.365 114.306C134.888 114.306 136.932 112.261 136.932 109.739V93.4178H111.767Z",
    fill: "url(#paint19_linear_465_8501)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.08905 84.6317V84.9617C4.08905 90.7108 7.91846 95.7699 13.4641 97.2861C27.8979 101.232 50.362 103.769 75.5976 103.769C100.833 103.769 123.297 101.232 137.731 97.2861C143.277 95.7699 147.106 90.7111 147.106 84.9617C147.106 84.8523 147.106 84.7429 147.106 84.6329C147.106 78.6014 141.438 74.1841 135.588 75.6511C121.127 79.277 99.6214 81.5764 75.5976 81.5764C51.5738 81.5764 30.0679 79.277 15.6076 75.6514C9.75699 74.1844 4.08905 78.6002 4.08905 84.6317Z",
    fill: "url(#paint20_linear_465_8501)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.655 80.7835C37.4785 79.8174 25.0429 78.0171 15.6076 75.6512C14.5161 75.3774 13.4311 75.3091 12.3879 75.4171V86.735C12.3879 88.68 13.3247 90.4018 14.7673 91.4883L22.6832 99.4041C36.4541 102.073 54.6497 103.714 74.637 103.765L51.655 80.7835Z",
    fill: "url(#paint21_linear_465_8501)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.304 75.7206C120.847 79.3059 99.4669 81.5765 75.5981 81.5765C74.5681 81.5765 73.5448 81.5706 72.5245 81.5623L94.2551 103.293C111.756 102.384 126.975 100.227 137.732 97.2865C142.509 95.9803 146.006 92.0426 146.885 87.3018L135.304 75.7206Z",
    fill: "url(#paint22_linear_465_8501)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.90521 67.0782V71.8303C1.90521 78.7064 6.53904 84.7464 13.2002 86.4529C28.107 90.2714 50.5249 92.7012 75.5976 92.7012C100.67 92.7012 123.088 90.2714 137.995 86.4529C144.656 84.7464 149.29 78.7067 149.29 71.8303V67.0782C149.29 63.6691 145.987 61.2191 142.734 62.2382C128.103 66.8217 103.498 69.8311 75.5976 69.8311C47.6976 69.8311 23.0926 66.8217 8.4611 62.2382C5.20815 61.2191 1.90521 63.6694 1.90521 67.0782Z",
    fill: "url(#paint23_linear_465_8501)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.735 62.2382C128.103 66.8217 103.498 69.8311 75.5981 69.8311C47.6981 69.8311 23.0931 66.8217 8.46159 62.2382C6.66423 61.6752 4.85482 62.1744 3.59247 63.3058L29.9913 89.7047C42.9951 91.5952 58.691 92.7011 75.5981 92.7011C100.671 92.7011 123.089 90.2714 137.995 86.4529C144.657 84.7464 149.29 78.7067 149.29 71.8303V67.0782C149.29 63.6694 145.987 61.2191 142.735 62.2382Z",
    fill: "url(#paint24_linear_465_8501)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.4 83.8167L125.711 66.1279C111.906 68.4468 94.5118 69.8312 75.5976 69.8312C71.4809 69.8312 67.4385 69.7641 63.4868 69.6376C63.1785 71.0273 63.5256 72.5638 64.6715 73.7097L83.4585 92.4967C84.2309 92.5223 85.01 92.5432 85.7894 92.5638C106.7 92.0038 125.141 89.7456 137.995 86.4526C140.006 85.9376 141.83 85.0256 143.4 83.8167Z",
    fill: "url(#paint25_linear_465_8501)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.293 66.3598C106.13 60.5536 85.6769 60.5536 66.5139 66.3598C63.3207 67.3274 62.3122 71.3503 64.6716 73.7098L87.4613 96.4995C92.1237 101.162 99.6831 101.162 104.345 96.4995L127.135 73.7098C129.495 71.3503 128.486 67.3274 125.293 66.3598Z",
    fill: "url(#paint26_linear_465_8501)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.2006 86.453C25.6371 89.6389 43.3035 91.8565 63.3759 92.5045L38.8221 67.9507C35.388 67.5768 32.0935 67.1527 28.9627 66.6821H12.3882V86.2171C12.6559 86.3021 12.9259 86.3827 13.2006 86.453Z",
    fill: "url(#paint27_linear_465_8501)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.3882 66.6821V86.7354C12.3882 90.0233 15.0535 92.6886 18.3415 92.6886C21.6294 92.6886 24.2947 90.0233 24.2947 86.7354V82.6727C24.2947 81.5336 25.218 80.6104 26.3571 80.6104C27.4962 80.6104 28.4194 81.5336 28.4194 82.6727V83.0033C28.4194 85.5257 30.4641 87.5704 32.9865 87.5704C35.5088 87.5704 37.5535 85.5257 37.5535 83.0033V66.6821H12.3882Z",
    fill: "url(#paint28_linear_465_8501)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.29 59.2649C149.29 38.419 1.90521 38.419 1.90521 59.2649C1.90521 62.859 6.28904 65.8331 13.5417 68.1879C16.1764 69.0431 18.6064 70.4317 20.6382 72.3143L20.8561 72.5161C25.2737 76.6099 31.6696 77.7587 37.2355 75.4581L37.2396 75.4564C41.9943 73.4911 47.4155 74.0196 51.7011 76.8664L52.1087 77.1373C56.8343 80.2761 62.9114 80.5337 67.8855 77.8061L68.2655 77.5976C72.834 75.0923 78.3652 75.0917 82.934 77.5964L83.317 77.8061C88.2917 80.5331 94.369 80.2746 99.0943 77.1352L99.5887 76.8067C103.85 73.9755 109.247 73.4687 113.961 75.4567C119.486 77.787 125.864 76.6646 130.262 72.5881L130.558 72.314C132.589 70.4311 135.019 69.0429 137.654 68.1876C144.906 65.8331 149.29 62.859 149.29 59.2649Z",
    fill: "url(#paint29_linear_465_8501)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.29 59.2662C149.29 62.8609 144.905 65.8312 137.652 68.1856C135.019 69.0438 132.588 70.4324 130.557 72.315L130.261 72.5891C127.39 75.2538 123.664 76.6556 119.89 76.6556C117.89 76.6556 115.873 76.2647 113.963 75.4559C109.25 73.4697 103.853 73.9777 99.5888 76.8085L99.0943 77.1365C94.3717 80.2729 88.292 80.5335 83.3179 77.8059L82.9358 77.5947C78.3661 75.0918 72.8346 75.0918 68.2646 77.5991L67.8873 77.8059C62.9132 80.5332 56.8335 80.2774 52.1108 77.1365L51.702 76.8668C47.4152 74.0179 41.9961 73.4921 37.242 75.4559H37.2376C33.9799 76.7994 30.4435 76.9703 27.1814 76.0535L8.21463 57.0868C7.20374 56.1565 6.34992 55.0647 5.68933 53.8606C14.1729 48.2482 35.8673 44.9456 59.8982 43.9526C70.2196 43.5259 80.977 43.5259 91.2982 43.9526C122.231 45.2288 149.29 50.3332 149.29 59.2662Z",
    fill: "url(#paint30_linear_465_8501)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.08905 47.347V47.677C4.08905 53.4261 7.91846 58.4852 13.4641 60.0014C27.8979 63.9476 50.362 66.484 75.5976 66.484C100.833 66.484 123.297 63.9476 137.731 60.0014C143.277 58.4852 147.106 53.4264 147.106 47.677C147.106 47.5676 147.106 47.4581 147.106 47.3481C147.106 41.3167 141.438 36.8996 135.588 38.3664C121.127 41.9923 99.6214 44.2917 75.5976 44.2917C51.5738 44.2917 30.0679 41.9923 15.6076 38.3667C9.75699 36.8996 4.08905 41.3155 4.08905 47.347Z",
    fill: "url(#paint31_linear_465_8501)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.106 47.3497V47.6776C147.106 53.4247 143.278 58.4844 137.733 60.0032C123.296 63.9485 100.833 66.4826 75.5976 66.4826C55.3276 66.4826 36.8462 64.8471 22.8762 62.16L4.70911 43.9929C6.33587 39.8006 10.91 37.19 15.6056 38.3671C30.0656 41.9932 51.5756 44.2894 75.5973 44.2894C99.6191 44.2894 121.129 41.9932 135.589 38.3671C141.44 36.8979 147.106 41.315 147.106 47.3497Z",
    fill: "url(#paint32_linear_465_8501)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.598 39.2271C150.598 60.073 0.5979 60.073 0.5979 39.2271C0.5979 18.3812 34.1764 1.48242 75.5979 1.48242C117.019 1.48242 150.598 18.3812 150.598 39.2271Z",
    fill: "url(#paint33_linear_465_8501)"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M126.339 34.8451C127.708 34.8451 128.818 33.7351 128.818 32.366C128.818 30.9968 127.708 29.8868 126.339 29.8868C124.969 29.8868 123.859 30.9968 123.859 32.366C123.859 33.7351 124.969 34.8451 126.339 34.8451Z",
    fill: "url(#paint34_linear_465_8501)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M121.735 40.7345C122.817 40.7345 123.693 39.8582 123.693 38.7772C123.693 37.6962 122.817 36.8198 121.735 36.8198C120.654 36.8198 119.778 37.6962 119.778 38.7772C119.778 39.8582 120.654 40.7345 121.735 40.7345Z",
    fill: "url(#paint35_linear_465_8501)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M130.266 41.5995C130.918 41.5995 131.446 41.0712 131.446 40.4195C131.446 39.7678 130.918 39.2395 130.266 39.2395C129.615 39.2395 129.086 39.7678 129.086 40.4195C129.086 41.0712 129.615 41.5995 130.266 41.5995Z",
    fill: "url(#paint36_linear_465_8501)"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M139.448 36.0666C140.459 36.0666 141.28 35.2463 141.28 34.2345C141.28 33.2227 140.459 32.4025 139.448 32.4025C138.436 32.4025 137.616 33.2227 137.616 34.2345C137.616 35.2463 138.436 36.0666 139.448 36.0666Z",
    fill: "url(#paint37_linear_465_8501)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M133.649 36.3042C134.448 36.3042 135.096 35.6567 135.096 34.858C135.096 34.0593 134.448 33.4119 133.649 33.4119C132.851 33.4119 132.203 34.0593 132.203 34.858C132.203 35.6567 132.851 36.3042 133.649 36.3042Z",
    fill: "url(#paint38_linear_465_8501)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M136.948 41.2375C137.429 41.2375 137.82 40.8471 137.82 40.3655C137.82 39.8838 137.429 39.4934 136.948 39.4934C136.466 39.4934 136.076 39.8838 136.076 40.3655C136.076 40.8471 136.466 41.2375 136.948 41.2375Z",
    fill: "url(#paint39_linear_465_8501)"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M0.5979 39.2274C0.5979 60.0733 150.598 60.0733 150.598 39.2274C150.598 35.3806 149.451 31.6689 147.326 28.1721H3.86996C1.74467 31.6686 0.5979 35.3804 0.5979 39.2274Z",
    fill: "url(#paint40_linear_465_8501)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.1126 34.6153C44.3794 34.6153 46.217 33.8106 46.217 32.818C46.217 31.8253 44.3794 31.0206 42.1126 31.0206C39.8458 31.0206 38.0082 31.8253 38.0082 32.818C38.0082 33.8106 39.8458 34.6153 42.1126 34.6153Z",
    fill: "url(#paint41_linear_465_8501)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.4367 34.6153C66.7035 34.6153 68.5411 33.8106 68.5411 32.818C68.5411 31.8253 66.7035 31.0206 64.4367 31.0206C62.1699 31.0206 60.3323 31.8253 60.3323 32.818C60.3323 33.8106 62.1699 34.6153 64.4367 34.6153Z",
    fill: "url(#paint42_linear_465_8501)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.7598 34.6153C89.0266 34.6153 90.8642 33.8106 90.8642 32.818C90.8642 31.8253 89.0266 31.0206 86.7598 31.0206C84.493 31.0206 82.6554 31.8253 82.6554 32.818C82.6554 33.8106 84.493 34.6153 86.7598 34.6153Z",
    fill: "url(#paint43_linear_465_8501)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.084 34.6153C111.351 34.6153 113.188 33.8106 113.188 32.818C113.188 31.8253 111.351 31.0206 109.084 31.0206C106.817 31.0206 104.98 31.8253 104.98 32.818C104.98 33.8106 106.817 34.6153 109.084 34.6153Z",
    fill: "url(#paint44_linear_465_8501)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.9507 24.2803C33.2175 24.2803 35.0551 23.4756 35.0551 22.4829C35.0551 21.4902 33.2175 20.6855 30.9507 20.6855C28.6839 20.6855 26.8463 21.4902 26.8463 22.4829C26.8463 23.4756 28.6839 24.2803 30.9507 24.2803Z",
    fill: "url(#paint45_linear_465_8501)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.2748 24.2803C55.5416 24.2803 57.3792 23.4756 57.3792 22.4829C57.3792 21.4902 55.5416 20.6855 53.2748 20.6855C51.008 20.6855 49.1704 21.4902 49.1704 22.4829C49.1704 23.4756 51.008 24.2803 53.2748 24.2803Z",
    fill: "url(#paint46_linear_465_8501)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.5979 24.2803C77.8647 24.2803 79.7023 23.4756 79.7023 22.4829C79.7023 21.4902 77.8647 20.6855 75.5979 20.6855C73.3311 20.6855 71.4935 21.4902 71.4935 22.4829C71.4935 23.4756 73.3311 24.2803 75.5979 24.2803Z",
    fill: "url(#paint47_linear_465_8501)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.9217 24.2803C100.189 24.2803 102.026 23.4756 102.026 22.4829C102.026 21.4902 100.189 20.6855 97.9217 20.6855C95.6549 20.6855 93.8173 21.4902 93.8173 22.4829C93.8173 23.4756 95.6549 24.2803 97.9217 24.2803Z",
    fill: "url(#paint48_linear_465_8501)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.245 24.2803C122.512 24.2803 124.35 23.4756 124.35 22.4829C124.35 21.4902 122.512 20.6855 120.245 20.6855C117.978 20.6855 116.141 21.4902 116.141 22.4829C116.141 23.4756 117.978 24.2803 120.245 24.2803Z",
    fill: "url(#paint49_linear_465_8501)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.1126 13.9455C44.3794 13.9455 46.217 13.1408 46.217 12.1482C46.217 11.1555 44.3794 10.3508 42.1126 10.3508C39.8458 10.3508 38.0082 11.1555 38.0082 12.1482C38.0082 13.1408 39.8458 13.9455 42.1126 13.9455Z",
    fill: "url(#paint50_linear_465_8501)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.4367 13.9455C66.7035 13.9455 68.5411 13.1408 68.5411 12.1482C68.5411 11.1555 66.7035 10.3508 64.4367 10.3508C62.1699 10.3508 60.3323 11.1555 60.3323 12.1482C60.3323 13.1408 62.1699 13.9455 64.4367 13.9455Z",
    fill: "url(#paint51_linear_465_8501)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.7598 13.9455C89.0266 13.9455 90.8642 13.1408 90.8642 12.1482C90.8642 11.1555 89.0266 10.3508 86.7598 10.3508C84.493 10.3508 82.6554 11.1555 82.6554 12.1482C82.6554 13.1408 84.493 13.9455 86.7598 13.9455Z",
    fill: "url(#paint52_linear_465_8501)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.084 13.9455C111.351 13.9455 113.188 13.1408 113.188 12.1482C113.188 11.1555 111.351 10.3508 109.084 10.3508C106.817 10.3508 104.98 11.1555 104.98 12.1482C104.98 13.1408 106.817 13.9455 109.084 13.9455Z",
    fill: "url(#paint53_linear_465_8501)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.5979 3.61058C77.8647 3.61058 79.7023 2.80587 79.7023 1.81322C79.7023 0.820571 77.8647 0.0158691 75.5979 0.0158691C73.3311 0.0158691 71.4935 0.820571 71.4935 1.81322C71.4935 2.80587 73.3311 3.61058 75.5979 3.61058Z",
    fill: "url(#paint54_linear_465_8501)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.529 3.82036C101.334 4.79389 99.3741 5.22271 97.1515 4.77859C94.9285 4.33447 93.2841 3.18506 93.4788 2.21153C93.6732 1.238 95.6332 0.80918 97.8559 1.2533C100.079 1.69741 101.723 2.84683 101.529 3.82036Z",
    fill: "url(#paint55_linear_465_8501)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.6678 3.82036C49.8623 4.79389 51.8223 5.22271 54.0449 4.77859C56.2678 4.33447 57.9122 3.18506 57.7175 2.21153C57.5228 1.238 55.5631 0.80918 53.3405 1.2533C51.1175 1.69771 49.4731 2.84683 49.6678 3.82036Z",
    fill: "url(#paint56_linear_465_8501)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_465_8501",
    x1: 74.962,
    y1: 122.876,
    x2: 84.8476,
    y2: 161.968,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAA68E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2061,
    stopColor: "#FBA682"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5808,
    stopColor: "#FDA861"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFA936"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_465_8501",
    x1: 108.339,
    y1: 152.286,
    x2: 88.2686,
    y2: 99.5635,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F82814",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2454,
    stopColor: "#F12817",
    stopOpacity: 0.245
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6052,
    stopColor: "#DD2820",
    stopOpacity: 0.605
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C0272D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_465_8501",
    x1: 138.066,
    y1: 132.497,
    x2: 130.764,
    y2: 113.625,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F82814",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2454,
    stopColor: "#F12817",
    stopOpacity: 0.245
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6052,
    stopColor: "#DD2820",
    stopOpacity: 0.605
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C0272D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_465_8501",
    x1: 24.1377,
    y1: 134.429,
    x2: 17.803,
    y2: 124.543,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F82814",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2454,
    stopColor: "#F12817",
    stopOpacity: 0.245
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6052,
    stopColor: "#DD2820",
    stopOpacity: 0.605
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C0272D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_465_8501",
    x1: 19.104,
    y1: 140.174,
    x2: 14.103,
    y2: 132.37,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F82814",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2454,
    stopColor: "#F12817",
    stopOpacity: 0.245
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6052,
    stopColor: "#DD2820",
    stopOpacity: 0.605
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C0272D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_465_8501",
    x1: 27.0008,
    y1: 140.82,
    x2: 23.9858,
    y2: 136.115,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F82814",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2454,
    stopColor: "#F12817",
    stopOpacity: 0.245
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6052,
    stopColor: "#DD2820",
    stopOpacity: 0.605
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C0272D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_465_8501",
    x1: 34.4887,
    y1: 135.761,
    x2: 36.8108,
    y2: 127.404,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F82814",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2454,
    stopColor: "#F12817",
    stopOpacity: 0.245
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6052,
    stopColor: "#DD2820",
    stopOpacity: 0.605
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C0272D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_465_8501",
    x1: 28.8461,
    y1: 135.82,
    x2: 30.6791,
    y2: 129.222,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F82814",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2454,
    stopColor: "#F12817",
    stopOpacity: 0.245
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6052,
    stopColor: "#DD2820",
    stopOpacity: 0.605
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C0272D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_465_8501",
    x1: 32.3806,
    y1: 140.486,
    x2: 33.4861,
    y2: 136.508,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F82814",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2454,
    stopColor: "#F12817",
    stopOpacity: 0.245
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6052,
    stopColor: "#DD2820",
    stopOpacity: 0.605
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C0272D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_465_8501",
    x1: 75.5972,
    y1: 138.039,
    x2: 75.5972,
    y2: 156.401,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F82814",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2454,
    stopColor: "#F12817",
    stopOpacity: 0.245
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6052,
    stopColor: "#DD2820",
    stopOpacity: 0.605
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C0272D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_465_8501",
    x1: 75.5976,
    y1: 102.242,
    x2: 75.5976,
    y2: 134.373,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A57C52"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1339,
    stopColor: "#A26C4A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5155,
    stopColor: "#994336"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8174,
    stopColor: "#942A2A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#922125"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_465_8501",
    x1: 77.1851,
    y1: 116.95,
    x2: 75.8372,
    y2: 90.5887,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#42210B",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#42210B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_465_8501",
    x1: 142.06,
    y1: 125.063,
    x2: 123.974,
    y2: 102.483,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#42210B",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#42210B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_465_8501",
    x1: 89.3662,
    y1: 133.364,
    x2: 84.8726,
    y2: 114.604,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#42210B",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#42210B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_465_8501",
    x1: 70.3544,
    y1: 102.624,
    x2: 96.7091,
    y2: 128.979,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD945"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3043,
    stopColor: "#FFCD3E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8558,
    stopColor: "#FFAD2B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFA325"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_465_8501",
    x1: 75.5976,
    y1: 93.7041,
    x2: 75.5976,
    y2: 120.991,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BADA00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2269,
    stopColor: "#B0CE00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6378,
    stopColor: "#95AE00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#798C00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_465_8501",
    x1: 77.2767,
    y1: 111.954,
    x2: 77.5764,
    y2: 86.4918,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#798C00",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6542,
    stopColor: "#556100",
    stopOpacity: 0.654
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#464F00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_465_8501",
    x1: 55.825,
    y1: 113.067,
    x2: 30.2123,
    y2: 66.785,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#798C00",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6542,
    stopColor: "#556100",
    stopOpacity: 0.654
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#464F00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_465_8501",
    x1: 133.169,
    y1: 115.138,
    x2: 123.396,
    y2: 97.6137,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#798C00",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6542,
    stopColor: "#556100",
    stopOpacity: 0.654
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#464F00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_465_8501",
    x1: 120.599,
    y1: 99.637,
    x2: 131.679,
    y2: 113.9,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDECF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3791,
    stopColor: "#FDC4B0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7655,
    stopColor: "#FBAE97"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAA68E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_465_8501",
    x1: 75.5976,
    y1: 89.8847,
    x2: 75.5976,
    y2: 103.382,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6359"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2243,
    stopColor: "#FE5B50"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5952,
    stopColor: "#FC4637"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F82814"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_465_8501",
    x1: 47.4603,
    y1: 108.867,
    x2: 38.1738,
    y2: 77.8627,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F82814",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C0272D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_465_8501",
    x1: 117.666,
    y1: 105.803,
    x2: 111.975,
    y2: 90.525,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F82814",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C0272D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_465_8501",
    x1: 75.5976,
    y1: 64.9567,
    x2: 75.5976,
    y2: 97.0879,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A57C52"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1339,
    stopColor: "#A26C4A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5155,
    stopColor: "#994336"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8174,
    stopColor: "#942A2A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#922125"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear_465_8501",
    x1: 77.1851,
    y1: 79.6655,
    x2: 75.8372,
    y2: 53.3041,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#42210B",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#42210B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear_465_8501",
    x1: 114.363,
    y1: 97.9432,
    x2: 99.535,
    y2: 70.6832,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#42210B",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#42210B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint26_linear_465_8501",
    x1: 90.6601,
    y1: 65.3392,
    x2: 117.015,
    y2: 91.6939,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD945"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3043,
    stopColor: "#FFCD3E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8558,
    stopColor: "#FFAD2B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFA325"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint27_linear_465_8501",
    x1: 39.318,
    y1: 93.6362,
    x2: 32.7277,
    y2: 74.0148,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#42210B",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#42210B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint28_linear_465_8501",
    x1: 21.22,
    y1: 72.9013,
    x2: 32.3,
    y2: 87.1636,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDECF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3791,
    stopColor: "#FDC4B0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7655,
    stopColor: "#FBAE97"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAA68E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint29_linear_465_8501",
    x1: 75.5976,
    y1: 56.419,
    x2: 75.5976,
    y2: 83.7058,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BADA00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2269,
    stopColor: "#B0CE00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6378,
    stopColor: "#95AE00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#798C00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint30_linear_465_8501",
    x1: 77.2767,
    y1: 74.6715,
    x2: 77.5764,
    y2: 49.2088,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#798C00",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6542,
    stopColor: "#556100",
    stopOpacity: 0.654
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#464F00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint31_linear_465_8501",
    x1: 75.5976,
    y1: 52.5996,
    x2: 75.5976,
    y2: 66.097,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6359"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2243,
    stopColor: "#FE5B50"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5952,
    stopColor: "#FC4637"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F82814"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint32_linear_465_8501",
    x1: 75.6985,
    y1: 66.7938,
    x2: 75.9232,
    y2: 44.3268,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F82814",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C0272D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint33_linear_465_8501",
    x1: 67.77,
    y1: 8.69507,
    x2: 81.7888,
    y2: 61.6048,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAA68E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2061,
    stopColor: "#FBA682"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5808,
    stopColor: "#FDA861"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFA936"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint34_linear_465_8501",
    x1: 128.401,
    y1: 35.5783,
    x2: 122.067,
    y2: 25.6929,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F82814",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2454,
    stopColor: "#F12817",
    stopOpacity: 0.245
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6052,
    stopColor: "#DD2820",
    stopOpacity: 0.605
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C0272D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint35_linear_465_8501",
    x1: 123.368,
    y1: 41.324,
    x2: 118.367,
    y2: 33.5199,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F82814",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2454,
    stopColor: "#F12817",
    stopOpacity: 0.245
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6052,
    stopColor: "#DD2820",
    stopOpacity: 0.605
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C0272D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint36_linear_465_8501",
    x1: 131.265,
    y1: 41.9694,
    x2: 128.25,
    y2: 37.2643,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F82814",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2454,
    stopColor: "#F12817",
    stopOpacity: 0.245
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6052,
    stopColor: "#DD2820",
    stopOpacity: 0.605
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C0272D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint37_linear_465_8501",
    x1: 138.722,
    y1: 36.9244,
    x2: 141.044,
    y2: 28.5672,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F82814",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2454,
    stopColor: "#F12817",
    stopOpacity: 0.245
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6052,
    stopColor: "#DD2820",
    stopOpacity: 0.605
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C0272D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint38_linear_465_8501",
    x1: 133.079,
    y1: 36.9833,
    x2: 134.912,
    y2: 30.3856,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F82814",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2454,
    stopColor: "#F12817",
    stopOpacity: 0.245
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6052,
    stopColor: "#DD2820",
    stopOpacity: 0.605
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C0272D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint39_linear_465_8501",
    x1: 136.614,
    y1: 41.649,
    x2: 137.719,
    y2: 37.6717,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F82814",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2454,
    stopColor: "#F12817",
    stopOpacity: 0.245
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6052,
    stopColor: "#DD2820",
    stopOpacity: 0.605
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C0272D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint40_linear_465_8501",
    x1: 75.5979,
    y1: 35.0718,
    x2: 75.5979,
    y2: 61.7615,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F82814",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2497,
    stopColor: "#F32816",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5421,
    stopColor: "#E5281D",
    stopOpacity: 0.542
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8547,
    stopColor: "#CE2727",
    stopOpacity: 0.855
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C0272D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint41_linear_465_8501",
    x1: 41.7155,
    y1: 31.6665,
    x2: 43.2135,
    y2: 36.01,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDECF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3791,
    stopColor: "#FDC4B0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7655,
    stopColor: "#FBAE97"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAA68E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint42_linear_465_8501",
    x1: 64.0397,
    y1: 31.6665,
    x2: 65.5373,
    y2: 36.01,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDECF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3791,
    stopColor: "#FDC4B0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7655,
    stopColor: "#FBAE97"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAA68E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint43_linear_465_8501",
    x1: 86.3627,
    y1: 31.6665,
    x2: 87.8607,
    y2: 36.01,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDECF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3791,
    stopColor: "#FDC4B0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7655,
    stopColor: "#FBAE97"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAA68E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint44_linear_465_8501",
    x1: 108.687,
    y1: 31.6665,
    x2: 110.185,
    y2: 36.01,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDECF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3791,
    stopColor: "#FDC4B0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7655,
    stopColor: "#FBAE97"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAA68E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint45_linear_465_8501",
    x1: 30.5536,
    y1: 21.3314,
    x2: 32.0516,
    y2: 25.6753,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDECF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3791,
    stopColor: "#FDC4B0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7655,
    stopColor: "#FBAE97"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAA68E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint46_linear_465_8501",
    x1: 52.8778,
    y1: 21.3314,
    x2: 54.3754,
    y2: 25.6753,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDECF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3791,
    stopColor: "#FDC4B0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7655,
    stopColor: "#FBAE97"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAA68E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint47_linear_465_8501",
    x1: 75.2008,
    y1: 21.3314,
    x2: 76.6988,
    y2: 25.6753,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDECF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3791,
    stopColor: "#FDC4B0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7655,
    stopColor: "#FBAE97"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAA68E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint48_linear_465_8501",
    x1: 97.5247,
    y1: 21.3314,
    x2: 99.0226,
    y2: 25.6753,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDECF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3791,
    stopColor: "#FDC4B0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7655,
    stopColor: "#FBAE97"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAA68E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint49_linear_465_8501",
    x1: 119.848,
    y1: 21.3314,
    x2: 121.346,
    y2: 25.6753,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDECF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3791,
    stopColor: "#FDC4B0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7655,
    stopColor: "#FBAE97"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAA68E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint50_linear_465_8501",
    x1: 41.7155,
    y1: 10.9967,
    x2: 43.2135,
    y2: 15.3402,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDECF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3791,
    stopColor: "#FDC4B0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7655,
    stopColor: "#FBAE97"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAA68E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint51_linear_465_8501",
    x1: 64.0397,
    y1: 10.9967,
    x2: 65.5373,
    y2: 15.3402,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDECF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3791,
    stopColor: "#FDC4B0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7655,
    stopColor: "#FBAE97"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAA68E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint52_linear_465_8501",
    x1: 86.3627,
    y1: 10.9967,
    x2: 87.8607,
    y2: 15.3402,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDECF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3791,
    stopColor: "#FDC4B0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7655,
    stopColor: "#FBAE97"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAA68E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint53_linear_465_8501",
    x1: 108.687,
    y1: 10.9967,
    x2: 110.185,
    y2: 15.3402,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDECF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3791,
    stopColor: "#FDC4B0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7655,
    stopColor: "#FBAE97"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAA68E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint54_linear_465_8501",
    x1: 75.2008,
    y1: 0.661752,
    x2: 76.6988,
    y2: 5.00528,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDECF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3791,
    stopColor: "#FDC4B0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7655,
    stopColor: "#FBAE97"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAA68E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint55_linear_465_8501",
    x1: 97.3881,
    y1: 1.78608,
    x2: 98.0062,
    y2: 6.34068,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDECF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3791,
    stopColor: "#FDC4B0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7655,
    stopColor: "#FBAE97"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAA68E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint56_linear_465_8501",
    x1: 54.0401,
    y1: 1.82093,
    x2: 53.422,
    y2: 6.37582,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDECF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3791,
    stopColor: "#FDC4B0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7655,
    stopColor: "#FBAE97"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAA68E"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_465_8501"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 150,
    height: 150,
    fill: "white",
    transform: "translate(0.5979 0.0158691)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCategoryBurger);
export default __webpack_public_path__ + "static/media/icon-category-burger.4a6f5f4a.svg";
export { ForwardRef as ReactComponent };